<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent != null && localService.languageContent.general_config != undefined">
  <app-popup-header title="{{localService.languageContent.general_config.global_config_header}}"></app-popup-header>
  <div class="modal-body" *ngIf="wrapper != undefined" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-4">
        <input autocomplete="off" type="number" class="number" (keypress)="localService.isNumberOnly($event)"
          [(ngModel)]="wrapper.content.v2" [ngClass]="wrapper.content.v2 != null ? 'en' : ''"
          placeholder="{{localService.languageContent.general_config.key}}"
          title="{{localService.languageContent.general_config.key}}" />
      </div>
      <div class="col-8">
        <input autocomplete="off" type="text" [(ngModel)]="wrapper.content.v1"
          [ngClass]="wrapper.content.v1 != '' ? 'en' : ''"
          placeholder="{{localService.languageContent.general_config.code}}"
          title="{{localService.languageContent.general_config.code}}" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-language-container [(languageContents)]="wrapper.languageContents"
          (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event)"
          [IsShowAllLanguages]="true"></app-language-container>
      </div>
    </div>
    <br/>
    <div class="row">
      <div class="col-12">
        <textarea [(ngModel)]="wrapper.content.v3" [ngClass]="wrapper.content.v3 != '' ? 'en' : ''" rows="10"
          placeholder="{{localService.languageContent.general_config.value}}"
          title="{{localService.languageContent.general_config.value}}"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary"
      (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>